import React from "react";

import Airdrop from "./Airdrop";
import Home from "./Home";
import Images from "./Images";
import About from "./About";
import Roadmap from "./Roadmap";
import Campaign from "./Campaign";
import Community from "./Community";
import TeamSection from "./TeamSection";
import Partners from "./Partners";
import FAQ from "./FAQ";
import TheLore from "./TheLore";
function Main(props) {
  return (
    <div className="bg-[#0A0912] main-page">
      <Home />
      <div className="mt-[2vh]">
        <About />
        <TheLore />
        <Airdrop />
        <Images />

        <Roadmap />
        <Campaign />
        <TeamSection />
        <Partners />
        <FAQ />
        <Community />
      </div>
    </div>
  );
}

export default Main;
